import React from 'react';
import { Section } from './Section';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  name: 'María Fernández',
  location: 'Córdoba, Argentina',
  text: 'Hace un mes que cocino con este recetario y la diferencia es notable. Tengo más energía por las tardes y mis últimos análisis mostraron mejoras. Los desayunos se volvieron mi momento favorito del día. ¡Por fin algo rico y fácil!',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=150'
}, {
  name: 'Laura Gómez',
  location: 'Buenos Aires, Argentina',
  text: "Tengo Hashimoto y encontrar postres que no me inflamen era imposible. Probé los muffins de arándanos del recetario y no lo podía creer. Mi familia los come y ni se dan cuenta de que son 'saludables'. Excelente inversión.",
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=150'
}, {
  name: 'Sofía Ramírez',
  location: 'Rosario, Argentina',
  text: 'Lo que más destaco es que los ingredientes se consiguen en cualquier súper de barrio. No tuve que comprar cosas raras ni gastar una fortuna. La sopa antiinflamatoria de la cena me ayudó muchísimo con la retención de líquidos.',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=150'
}];
export const Testimonials = () => {
  return <Section className="bg-white" data-id="element-275">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-276">
        <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-277">
          Lo que dicen nuestros testimonios
        </h2>
        <p className="text-lg text-stone-600" data-id="element-278">
          Mujeres reales que ya están transformando su bienestar desde la
          cocina.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-279">
        {testimonials.map((testimonial, idx) => <div key={idx} className="bg-stone-50 p-8 rounded-2xl relative border border-stone-100" data-id="element-280">
            <QuoteIcon className="absolute top-6 right-6 w-10 h-10 text-brand-100" data-id="element-281" />
            <div className="flex text-amber-400 mb-6" data-id="element-282">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-283" />)}
            </div>
            <p className="text-stone-700 italic mb-8 relative z-10 leading-relaxed" data-id="element-284">
              "{testimonial.text}"
            </p>
            <div className="flex items-center gap-4" data-id="element-285">
              <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border-2 border-brand-200" data-id="element-286" />
              <div data-id="element-287">
                <p className="font-bold text-stone-900" data-id="element-288">{testimonial.name}</p>
                <p className="text-sm text-stone-500" data-id="element-289">{testimonial.location}</p>
              </div>
            </div>
          </div>)}
      </div>
    </Section>;
};